import * as angular from 'angular';

export default class RfpUnspscsService {
  baseUrl = '/aptitude/api/rfps/';

  constructor(private $http) {
    'ngInject';
  }

  // FIXME: this request is causing a redirect for some reason
  getUnspscs(rfpId: number) {
    return this.$http.get(`${this.baseUrl}${rfpId}/unspscs`, {
      cache: true
    });
  }

  addUnspsc(rfpId: number, unspscId: number) {
    // FIXME: the ability to pass in an array will be removed so only accepting a single unspsc Id
    // so posting single item array
    return this.$http.post(`${this.baseUrl}${rfpId}/unspscs`, [{ unspscId }]);
  }

  addUnspscsByStandardCategoryId(rfpId: number, standardCategoryId: number) {
    // FIXME: the ability to pass in an array will be removed so only accepting a single unspsc Id
    // so posting single item array
    return this.$http.post(`${this.baseUrl}${rfpId}/unspscs`, [
      { standardCategoryId }
    ]);
  }

  removeUnspsc(rfpId: number, unspscId: number) {
    return this.$http.delete(`${this.baseUrl}${rfpId}/unspscs/${unspscId}`);
  }

  removeUnspscsByStandardCategoryId(rfpId: number, standardCategoryId: number) {
    return this.$http.delete(
      `${this.baseUrl}${rfpId}/unspscs`,
      angular.extend({
        params: {
          standardCategoryId
        }
      })
    );
  }
}
